import { useMemo } from 'react';
import type { Params } from 'react-router';
import { useParams } from 'react-router';

/**
 * Provides the path with the basename param prefixed. Guarantees a trailing slash.
 * @returns {string} a path with a trailing slash.
 */
export function useBloomBasename(): string {
  const { basename } = useParams();
  const bloomBasename = useMemo(
    () => (basename ? `/${basename}/` : '/'),
    [basename]
  );

  return bloomBasename;
}

/**
 * Provides the path with the basename param prefixed. Compatible with actions and loaders. Guarantees a trailing slash.
 * @returns {string} a path with a trailing slash.
 */
export function bloomBasename(params: Params<string>): string {
  return params['basename'] ? `/${params['basename']}/` : '/';
}

export const deriveBasename = (menuUrl: string): string => {
  return new URL(menuUrl).pathname;
};
